import React from 'react';

interface Icon3DPartnershipProps {
  size?: string;
}

const Icon3DPartnership: React.FC<Icon3DPartnershipProps> = ({ size = 'w-6 h-6' }) => {
  return (
    <div className={`${size} relative inline-flex items-center justify-center`} style={{ perspective: '1200px' }}>
      <div 
        className="w-full h-full relative"
        style={{
          animation: 'handshake 3s ease-in-out infinite',
          transformStyle: 'preserve-3d'
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" className="w-full h-full" style={{ filter: 'drop-shadow(0 2px 8px rgba(59, 130, 246, 0.3))' }}>
          <defs>
            <linearGradient id="partnershipGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#3b82f6" />
              <stop offset="100%" stopColor="#1d4ed8" />
            </linearGradient>
          </defs>
          <path d="M3 12c0-1.5 1.5-3 3-3s3 1.5 3 3" fill="url(#partnershipGradient)" opacity="0.3" />
          <path d="M18 12c0-1.5-1.5-3-3-3s-3 1.5-3 3" fill="url(#partnershipGradient)" opacity="0.3" />
          <path d="M6 12L12 15L18 12" stroke="url(#partnershipGradient)" strokeWidth="2" fill="none" strokeLinecap="round" />
          <circle cx="6" cy="9" r="2.5" fill="url(#partnershipGradient)" opacity="0.7" />
          <circle cx="18" cy="9" r="2.5" fill="url(#partnershipGradient)" opacity="0.7" />
        </svg>
        <style>{`
          @keyframes handshake {
            0%, 100% { transform: rotateX(0deg) rotateZ(0deg); }
            50% { transform: rotateX(15deg) rotateZ(5deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Icon3DPartnership;
